$.fn.ajaxMail = function() {
  var form = $(this),
    inputs = form.find('[required]'),
    trigger = form.find('[type="submit"]'),
    triggerText = trigger.html(),
    alert = form.find('.alert'),
    busy = null;

  function init(){
    trigger.on('click', function(e) {
      var error = false,
        sent = null;

      if (busy){
        busy.abort();
      }

      error = validate(inputs);

      if(!error) {

        sendMail(form);

      } 
      else {

        setNotification('input-errors');
        
      }

      e.preventDefault();
    });

    inputs.on('keyup focusout', function() {
      var input = $(this);

      validate(input);
    });
  }

  function validate(inputs) {
    var error = false;

    inputs.each( function() {
      var parent = $(this).parent(),
        val = $.trim($(this).val());

      // on vérifie si le champ est vide ou non
      if (val === '' || val === '0') {

        parent.addClass('has-error');
        error = true;

      } else {

        parent.removeClass('has-error');

      }

    });

    return error;
  }

  function sendMail(form) {
    var re = null;

      busy = $.ajax({
        url: ajaxurl,
        type:'POST',
        data:form.serialize(),
        success: function( response ){
          console.log(response);
          setNotification(response);
      }
    });   
  }

  function setNotification(response){
    
    trigger.html(triggerText);

    switch(response) {
      case 'success':

        form[0].reset();

        alert.removeClass('alert-info').addClass('alert-success').html('Merci ! votre message a bien été envoyé, nous vous contacterons dans les plus brefs délais.');
  
      break;

      case 'error':

        alert.removeClass('alert-info').addClass('alert-danger').html('Nous sommes désolé mais une erreur est survenue.');

      break;

      case 'input-errors':
        alert.removeClass('alert-info').addClass('alert-warning').html('Merci de remplir tous les champ ci-dessus.');
      break;

      default:

      break;
    }

    alert.stop().slideDown(function(){
      alert.delay(5000).slideUp();
    });
  }

  init();
};


$.fn.fitHeight = function() {
    var elements = $(this),

        elementHeights = $(this).map(function() {
          return $(this).height();
        }).get(),

        maxHeight = Math.max.apply(null, elementHeights);
    if(elements.length > 0) {
      elements.height(maxHeight);      
    }
};

$.fn.preload = function(imgType, callback, apply) {
  var type = imgType || null,
    elements = $(this),
    nbElements = elements.length,
    progress = 0;

  function percent(num, range){
    return num / range * 100;
  }
  

  function loadImg(el) {
    var src = el.attr('data-img-src'),
      img = new Image(),
      loaded = null;

    img.src = src;      

    img.onload = function() {

      if(type === 'background' && apply === true ) {        
        el.css({'background-image': 'url('+src+')'});
      }
      else if(apply === true) {
        el.attr('src', src); 
      }

      el.addClass('loaded').trigger('preloaded');
    };

    img.onerror = function() {
      el.trigger('error');
    };
  }

  function triggerCallback() {
    var percentage = 0;

    progress++;

    percentage = percent(progress, nbElements);

    $('.loader .load-progress span').html(percentage);

    if (typeof callback === 'function' && progress === nbElements) {
       callback();
    }
    else if(typeof callback !== 'function') {
      console.log('invalid callback');    
    }   
  }

  function init() {

    var el = null;

    for (var i = 0 ; i < nbElements; i++) {
      el = elements.eq(i);

      loadImg(el);

      el.on('preloaded', triggerCallback);
    }  
  }

  init();
};

function inlineSVG() {
  $('img.svg').each(function(){
    var $img = $(this);
    var imgID = $img.attr('id');
    var imgClass = $img.attr('class');
    var imgURL = $img.attr('src');

    $.get(imgURL, function(data) {
        // Get the SVG tag, ignore the rest
        var $svg = $(data).find('svg');

        // Add replaced image's ID to the new SVG
        if(typeof imgID !== 'undefined') {
            $svg = $svg.attr('id', imgID);
        }
        // Add replaced image's classes to the new SVG
        if(typeof imgClass !== 'undefined') {
            $svg = $svg.attr('class', imgClass+' replaced-svg');
        }

        // Remove any invalid XML tags as per http://validator.w3.org
        $svg = $svg.removeAttr('xmlns:a');

        // Replace image with new SVG
        $img.replaceWith($svg);

    }, 'xml');

  });
}

function scrollHeaderListener() {
  $( window ).on('scroll resize', function() {
    var banner = $('.banner'),
        navHeight = banner.height(),
        offset = $( window ).scrollTop();

    if(offset > 0) {
      banner.addClass('navbar-white');
    }
    else {
      banner.removeClass('navbar-white');
    }
  });
}

// Gestion de la mention CNIL
function getCookieExpireDate() {
    var cookieTimeout = 34214400000; // Le nombre de millisecondes que font 13 mois
    var date = new Date();
    date.setTime(date.getTime() + cookieTimeout);
    var expires = "; expires=" + date.toGMTString();
    return expires;
}

// Retourne la chaine de caractère correspondant à nom=valeur
function getCookie(NomDuCookie) {
    if (document.cookie.length > 0) {
        begin = document.cookie.indexOf(NomDuCookie + "=");
        if (begin !== -1) {
            begin += NomDuCookie.length + 1;
            end = document.cookie.indexOf(";", begin);
            if (end === -1){
              end = document.cookie.length;
            } 
            return unescape(document.cookie.substring(begin, end));
        }
    }
    return null;
}

// Cette fonction est appelée pour afficher la demande de consentement
function askConsent() {
    var body = $('body');
    var div = ' <div id="cookie-banner"><div class="hidden-print" id="consentement">' +
        ' <div class="container">Le site stancom.fr utilise des cookies pour personnaliser votre visite et vous assurer une meilleure expérience. ' +
        ' <br>En continuant votre visite, vous acceptez l’utilisation des cookies. ' +
        ' Pour en savoir plus, <a href="/cookies">cliquez ici</a>' +
        ' <button type="button" class="close" data-dismiss="modal">&times;</button>' +        
        ' </div>' +
        ' </div></div>';
    body.append(div);

    $("#consentement [data-dismiss]").one('click', function() {
        var consentCookie = getCookie('hasConsent');
        if (!consentCookie) {
            document.cookie = 'hasConsent=true; ' + getCookieExpireDate() + ' ; path=/';
        }
        $('#cookie-banner').addClass('closed');
        $('#cookie-banner').one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function(){
          $(this).remove();
        });
    });
}

/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 *
 * Google CDN, Latest jQuery
 * To use the default WordPress version of jQuery, go to lib/config.php and
 * remove or comment out: add_theme_support('jquery-cdn');
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
      },
      finalize: function() {
        var isHome = $('body').hasClass('home');

        inlineSVG();

        $('.product h3').fitHeight();
        $('.hentry .well').fitHeight();         

        if(!isHome) {
          scrollHeaderListener();
        }

        //Ce bout de code vérifie que le consentement n'a pas déjà été obtenu avant d'afficher
        // la baniére
        var consentCookie = getCookie('hasConsent');
        if (!consentCookie) { //L'utilisateur n'a pas encore de cookie de consentement
            var referrer_host = document.referrer.split('/')[2];
            if (referrer_host !== document.location.hostname) { //si il vient d'un autre site
                //on désactive le tracking et on affiche la demande de consentement
                // window[disableStr] = true;
                $(document).one('ready', askConsent);
            } else { //sinon on lui dépose un cookie
                document.cookie = 'hasConsent=true; ' + getCookieExpireDate() + ' ; path=/';
            }
        }

      }
    },

    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page      
      },
      finalize: function() {
        var hideLoader = function() {
              setTimeout(function(){
                $('.loader').addClass('masked');
              }, 1000);
            };
            
        $('.fullpage').fullpage({
          resize: false,
          navigation: true,
          navigationPosition: 'left',
          css3: true,
          scrollingSpeed: 600,
          easingcss3: 'ease-out',
          autoScrolling: true,
          touchSensitivity: 10,
          normalScrollElementTouchThreshold: 5,
          responsive: 768
        });

        $('.scroll-down').click(function() {
          $.fn.fullpage.moveSectionDown();
        });              

        $('.preload').preload('background', hideLoader);

 
      }
    },
    
    'contact': {
      init: function() {

      },
      finalize: function() {
        $('.contact-form').ajaxMail();
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
